import { createSelector } from "reselect";
import unionBy from "lodash/unionBy";
import { widgetStateSelector } from "orion-components/AppState/Selectors";
import { defaultDeviceProfileWidgets } from "../Utils/DeviceProfileWidgets";

const getWidgetState = (state) => widgetStateSelector(state)?.widgetOrder || [];

export const deviceWidgetConfig = createSelector([getWidgetState], (widgetState) => {
	const defaultTypes = ["files", "activities", "linked_items", "cameras", "access_control", "map", "details", "cameraClusters", "alerting_zones"];

	const filteredDefault = defaultDeviceProfileWidgets?.filter((widget) => defaultTypes?.includes(widget.id));

	const widgetConfig = widgetState.length > 0 ? unionBy(widgetState, filteredDefault, "id") : filteredDefault;

	return widgetConfig;
});
